/**
 * wbk-table-interactive.js
 * WBK Übersichtstabelle – Zeilen-Selektion + Spalten-Filter
 * Wird von _updated_wbk-vergleich.liquid (sections/wbk-vergleich.liquid) geladen.
 * Stabile Datei – wird NICHT vom SEO-Generator überschrieben.
 *
 * Features:
 *   1) Zeilen-Selektion: Klick auf Zeile → grün markiert + Vergleichstool-Integration
 *   2) Spalten-Filter: Klick auf ▼ in Spaltenköpfen → Excel-ähnliches Dropdown
 */
(function () {
  'use strict';

  if (window.__wbkTableInteractiveLoaded) { return; }
  window.__wbkTableInteractiveLoaded = true;

  // Scroll-Anchoring verhindern (für Vergleichsleiste)
  document.documentElement.style.setProperty('overflow-anchor', 'none');
  document.body && (document.body.style.overflowAnchor = 'none');


  var STORAGE_KEY = 'wbk_compare_v1';
  var MAX_DEVICES = 4;
  var openDropdown = null;
  var activeFilters = {};

  // ══════════════════════════════════════════════════════════
  // HELPERS
  // ══════════════════════════════════════════════════════════

  function getCompareList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function setCompareList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_DEVICES))); }
    catch (e) {}
  }

  function showToast(msg) {
    var existing = document.querySelector('.wbk-toast');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.className = 'wbk-toast';
    toast.textContent = msg;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('wbk-toast--visible');
      });
    });
    setTimeout(function () {
      toast.classList.remove('wbk-toast--visible');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 350);
    }, 2800);
  }

  // ══════════════════════════════════════════════════════════
  // ZEILEN-SELEKTION
  // ══════════════════════════════════════════════════════════

  function syncRowSelection() {
    var table = document.querySelector('.wbk-seo-table');
    if (!table) return;
    var list = getCompareList();
    var selectedHandles = list.map(function (p) { return p.handle; });
    var rows = table.querySelectorAll('tr[data-handle]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var inList = selectedHandles.indexOf(row.dataset.handle) >= 0;
      row.classList.toggle('wbk-row--selected', inList);
    }
  }

  /**
   * Findet den Picker-Button für dieses Handle und klickt ihn,
   * wenn sein aktueller Zustand nicht dem gewünschten entspricht.
   * Returns true wenn Button gefunden, false wenn nicht vorhanden (Picker noch nicht gerendert).
   */
  function triggerPickerToggle(handle, wantSelected) {
    var btn = document.querySelector('.wbk-vgl__picker-item[data-handle="' + handle + '"]');
    if (!btn) return false;
    var isSelected = btn.classList.contains('wbk-vgl__picker-item--selected');
    if (isSelected !== wantSelected) {
      btn.click();
    }
    return true;
  }

  // Picker-Sync mit Retry (falls Picker noch nicht gerendert)
  function tryPickerSync(handle, wantSelected) {
    var attempts = 0;
    function attempt() {
      var btn = document.querySelector('.wbk-vgl__picker-item[data-handle="' + handle + '"]');
      if (btn) {
        var isSel = btn.classList.contains('wbk-vgl__picker-item--selected');
        if (isSel !== wantSelected) {
          var savedY = window.scrollY || window.pageYOffset;
          btn.click();
          // Mehrfach restaurieren um Scroll-Anchoring zu überwinden
          requestAnimationFrame(function() { window.scrollTo(0, savedY); });
          setTimeout(function() { window.scrollTo(0, savedY); }, 50);
          setTimeout(function() { window.scrollTo(0, savedY); }, 150);
        }
      } else if (attempts++ < 15) {
        setTimeout(attempt, 200);
      }
    }
    attempt();
  }

  // ─ "Zum Vergleich" Button ─────────────────────────────────────────────
  function initZumVergleichButton() {
    var btn = document.createElement('button');
    btn.id = 'wbk-zum-vergleich-btn';
    btn.innerHTML = '&#8679; Zum Vergleich';
    btn.title = 'Zum Wärmebildvergleich scrollen';
    btn.style.cssText = [
      'display:none','position:fixed','bottom:92px','right:24px',
      'background:#2f5233','color:#fff','border:none','border-radius:24px',
      'padding:10px 20px','font-size:0.9rem','font-weight:600',
      'cursor:pointer','box-shadow:0 4px 12px rgba(0,0,0,0.25)',
      'z-index:999','transition:opacity 0.2s'
    ].join(';');
    btn.addEventListener('click', function() {
      var target = document.getElementById('wbk-vergleich-root') ||
                   document.querySelector('.wbk-vgl, .wbk-berater');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    document.body.appendChild(btn);

    // Button anzeigen/verstecken je nach Auswahl
    function updateBtn() {
      var count = getCompareList().length;
      btn.style.display = count > 0 ? 'block' : 'none';
      btn.innerHTML = count > 0
        ? '&#8679; Zum Vergleich (' + count + ')'
        : '&#8679; Zum Vergleich';
    }
    window.addEventListener('storage', updateBtn);
    document.addEventListener('wbk:selectionChanged', updateBtn);

    updateBtn();
    // Bei jeder Auswahländerung updaten
    document.addEventListener('click', function(e) {
      if (e.target.closest('tr[data-handle]')) setTimeout(updateBtn, 50);
    });
  }

  function addToList(handle) {
    var list = getCompareList();
    var exists = list.some(function (p) { return p.handle === handle; });
    if (exists) return;
    var p = (window.WBK_DATA && window.WBK_DATA[handle]) || {};  // Fallback wenn WBK_DATA fehlt
    list.push({ handle: handle, title: p.title || handle, image: p.image || '', price: p.price || 0 });
    setCompareList(list);
    // Button sichtbar machen
    var _btn = document.getElementById('wbk-zum-vergleich-btn');
    if (_btn) { _btn.style.display = 'block'; _btn.textContent = '\u2191 Zum Vergleich (' + list.length + ')'; }
  }

  function removeFromList(handle) {
    var list = getCompareList();
    var exists = list.some(function (p) { return p.handle === handle; });
    if (!exists) return;

    setCompareList(list.filter(function (p) { return p.handle !== handle; }));
  }

  function initRowSelection() {
    var table = document.querySelector('.wbk-seo-table');
    if (!table) return;

    // Initial: Zustand aus localStorage
    syncRowSelection();

    // Klick-Handler
    table.addEventListener('click', function (e) {
      // Nur abfangen wenn: Selektor-Zelle geklickt, ODER Zeile geklickt aber kein Link
      var isSelCell = !!e.target.closest('.wbk-sel-td');
      var isLink = !isSelCell && (e.target.tagName === 'A' || !!e.target.closest('a'));
      if (isLink) return;

      var row = e.target.closest('tr[data-handle]');
      if (!row) return;

      var handle = row.dataset.handle;
      var isSelected = row.classList.contains('wbk-row--selected');

      if (isSelected) {
        // Deselect
        row.classList.remove('wbk-row--selected');
        removeFromList(handle);
      } else {
        // Selektieren – Max-Check
        var list = getCompareList();
        if (list.length >= MAX_DEVICES) {
          showToast('Maximal 4 Geräte können gleichzeitig verglichen werden.');
          return;
        }
        row.classList.add('wbk-row--selected');
        addToList(handle);
      }
    });

    // Sync wenn Picker-Tool den localStorage ändert (gleicher Tab via MutationObserver)
    var pickerRoot = document.getElementById('wbk-vergleich-root');
    if (pickerRoot) {
      var observer = new MutationObserver(function () {
        syncRowSelection();
      });
      observer.observe(pickerRoot, { childList: true, subtree: true });
    }

    // Cross-Tab-Sync
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) syncRowSelection();
    });
  }

  // ══════════════════════════════════════════════════════════
  // SPALTEN-FILTER
  // ══════════════════════════════════════════════════════════

  function closeDropdown() {
    if (openDropdown && openDropdown.parentNode) {
      openDropdown.parentNode.removeChild(openDropdown);
    }
    openDropdown = null;
  }

  function getUniqueValues(col, rows) {
    var seen = {};
    var values = [];
    for (var i = 0; i < rows.length; i++) {
      var val = (rows[i].dataset[col] || '—').trim();
      if (!seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    }
    return values.sort(function (a, b) {
      // Bucket-Sort: < zuerst, dann Ranges numerisch, > zuletzt
      var aLt = a.startsWith('<'), bLt = b.startsWith('<');
      var aGt = a.startsWith('>'), bGt = b.startsWith('>');
      if (aLt && !bLt) return -1;
      if (!aLt && bLt) return 1;
      if (aGt && !bGt) return 1;
      if (!aGt && bGt) return -1;
      var numA = parseFloat(a.replace(/[^0-9]/g, '').replace(',', '.') || '0');
      var numB = parseFloat(b.replace(/[^0-9]/g, '').replace(',', '.') || '0');
      if (!isNaN(numA) && !isNaN(numB) && numA !== numB) return numA - numB;
      return a.localeCompare(b, 'de');
    });
  }

  function applyFilters(table, allRows) {
    var hasAnyFilter = Object.keys(activeFilters).some(function (col) {
      return activeFilters[col] && activeFilters[col].length > 0;
    });

    var visibleCount = 0;
    for (var i = 0; i < allRows.length; i++) {
      var row = allRows[i];
      var visible = true;
      if (hasAnyFilter) {
        for (var col in activeFilters) {
          if (!activeFilters.hasOwnProperty(col)) continue;
          var allowed = activeFilters[col];
          if (!allowed || allowed.length === 0) continue;
          var val = (row.dataset[col] || '—').trim();
          if (allowed.indexOf(val) === -1) {
            visible = false;
            break;
          }
        }
      }
      row.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    }

    // Filter-Icons aktualisieren
    table.querySelectorAll('th[data-col]').forEach(function (th) {
      var col = th.dataset.col;
      var icon = th.querySelector('.wbk-filter-icon');
      if (!icon) return;
      var active = activeFilters[col] && activeFilters[col].length > 0;
      icon.classList.toggle('wbk-filter-active', active);
      icon.textContent = active ? '▼●' : '▼';
    });

    // Ergebnis-Zähler
    updateResultCount(table, allRows.length, visibleCount);
  }

  function updateResultCount(table, total, visible) {
    var wrap = table.closest('.wbk-seo-table-wrap');
    if (!wrap) return;

    var countEl = wrap.parentNode && wrap.parentNode.querySelector('.wbk-filter-count');
    if (!countEl) {
      countEl = document.createElement('div');
      countEl.className = 'wbk-filter-count';
      wrap.parentNode.insertBefore(countEl, wrap);
    }

    if (visible < total) {
      countEl.textContent = visible + ' von ' + total + ' Geräten angezeigt';
      countEl.style.color = '#2f5233';
      countEl.style.fontWeight = '500';
    } else {
      countEl.textContent = total + ' Geräte';
      countEl.style.color = '#888';
      countEl.style.fontWeight = 'normal';
    }
  }

  function buildDropdown(col, values, allRows, table) {
    var dropdown = document.createElement('div');
    dropdown.className = 'wbk-filter-dropdown';
    dropdown.dataset.col = col;

    var currentFilter = activeFilters[col] || [];

    // "Alle" Checkbox
    var allLabel = document.createElement('label');
    allLabel.className = 'wbk-filter-label wbk-filter-label--all';
    var allCheck = document.createElement('input');
    allCheck.type = 'checkbox';
    allCheck.checked = currentFilter.length === 0;
    allLabel.appendChild(allCheck);
    allLabel.appendChild(document.createTextNode(' Alle auswählen'));
    dropdown.appendChild(allLabel);

    var hr = document.createElement('div');
    hr.style.cssText = 'border-top:1px solid #eee;margin:5px 0 3px';
    dropdown.appendChild(hr);

    // Einzel-Checkboxen
    var itemChecks = [];
    values.forEach(function (val) {
      var label = document.createElement('label');
      label.className = 'wbk-filter-label';
      var check = document.createElement('input');
      check.type = 'checkbox';
      check.value = val;
      check.checked = currentFilter.length === 0 || currentFilter.indexOf(val) >= 0;
      itemChecks.push(check);
      label.appendChild(check);
      label.appendChild(document.createTextNode(' ' + val));
      dropdown.appendChild(label);
    });

    // "Alle" Logik
    allCheck.addEventListener('change', function () {
      var checked = this.checked;
      itemChecks.forEach(function (c) { c.checked = checked; });
      if (checked) {
        delete activeFilters[col];
      } else {
        activeFilters[col] = [];
      }
      applyFilters(table, allRows);
    });

    itemChecks.forEach(function (check) {
      check.addEventListener('change', function () {
        var selected = itemChecks
          .filter(function (c) { return c.checked; })
          .map(function (c) { return c.value; });
        allCheck.checked = selected.length === itemChecks.length;
        if (selected.length === 0 || selected.length === itemChecks.length) {
          delete activeFilters[col];
        } else {
          activeFilters[col] = selected;
        }
        applyFilters(table, allRows);
      });
    });

    // Buttons
    var btnRow = document.createElement('div');
    btnRow.style.cssText = 'display:flex;gap:6px;margin-top:10px;border-top:1px solid #eee;padding-top:8px';

    var resetBtn = document.createElement('button');
    resetBtn.type = 'button';
    resetBtn.className = 'wbk-filter-reset';
    resetBtn.textContent = '↺ Zurücksetzen';
    resetBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      delete activeFilters[col];
      itemChecks.forEach(function (c) { c.checked = true; });
      allCheck.checked = true;
      applyFilters(table, allRows);
    });

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'wbk-filter-apply';
    closeBtn.textContent = 'Schließen';
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeDropdown();
    });

    btnRow.appendChild(resetBtn);
    btnRow.appendChild(closeBtn);
    dropdown.appendChild(btnRow);

    return dropdown;
  }

  function positionDropdown(dropdown, th) {
    document.body.appendChild(dropdown);
    var rect = th.getBoundingClientRect();
    var scrollY = window.scrollY || window.pageYOffset;
    var scrollX = window.scrollX || window.pageXOffset;

    dropdown.style.position = 'absolute';
    dropdown.style.top = (rect.bottom + scrollY + 4) + 'px';
    dropdown.style.left = (rect.left + scrollX) + 'px';

    // Overflow-Korrektur
    var ddRect = dropdown.getBoundingClientRect();
    if (ddRect.right > window.innerWidth - 8) {
      dropdown.style.left = Math.max(scrollX + 8, rect.right + scrollX - ddRect.width) + 'px';
    }
    if (ddRect.bottom > window.innerHeight - 8) {
      dropdown.style.top = (rect.top + scrollY - ddRect.height - 4) + 'px';
    }
  }

  function initColumnFilters() {
    var table = document.querySelector('.wbk-seo-table');
    if (!table) return;

    var allRows = Array.from(table.querySelectorAll('tbody tr[data-handle]'));
    if (allRows.length === 0) return;

    // Initiale Zählung anzeigen
    updateResultCount(table, allRows.length, allRows.length);

    table.querySelectorAll('th.wbk-filterable[data-col]').forEach(function (th) {
      var col = th.dataset.col;
      var icon = th.querySelector('.wbk-filter-icon');
      if (!icon) return;

      var values = getUniqueValues(col, allRows);

      th.addEventListener('click', function (e) {
        e.stopPropagation();
        // Gleiches Dropdown → schließen (Toggle)
        if (openDropdown && openDropdown.dataset.col === col) {
          closeDropdown();
          return;
        }
        closeDropdown();

        var dropdown = buildDropdown(col, values, allRows, table);
        positionDropdown(dropdown, th);
        openDropdown = dropdown;
      });
    });

    // Außen-Klick → schließen
    document.addEventListener('click', function (e) {
      if (openDropdown && !openDropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // Scroll/Resize → schließen
    window.addEventListener('scroll', closeDropdown, { passive: true });
    window.addEventListener('resize', closeDropdown, { passive: true });
  }

  // ══════════════════════════════════════════════════════════
  // CSS-INJEKTION
  // ══════════════════════════════════════════════════════════

  function injectStyles() {
    var css = [
      /* ── Zeilen-Selektion ── */
      'tr[data-handle]{cursor:pointer}',
      'tr.wbk-row--selected td{background:#edf7ed!important;box-shadow:inset 3px 0 0 #2f5233}',
      'tr.wbk-row--selected td:first-child{font-weight:700}',
      'tr./* ✓ via .wbk-sel-icon::before */',
      'tr[data-handle]:not(.wbk-row--selected):hover td{background:#f4f9f4!important}',
      'tr.wbk-row--selected:hover td{background:#dff0df!important}',

      /* ── Filter-Spaltenköpfe ── */
      'th.wbk-filterable{cursor:pointer;user-select:none;white-space:nowrap}',
      'th.wbk-filterable:hover{background:#3d6b42!important}',
      '.wbk-filter-icon{font-size:.65em;color:rgba(255,255,255,.55);margin-left:5px;display:inline-block;vertical-align:middle;transition:color .15s;letter-spacing:-.05em}',
      '.wbk-filter-icon.wbk-filter-active{color:#a8e6a3;letter-spacing:0}',
      'th.wbk-filterable:hover .wbk-filter-icon{color:rgba(255,255,255,.9)}',

      /* ── Filter-Dropdown ── */
      '.wbk-filter-dropdown{background:#fff;border:1.5px solid #ccc;border-radius:9px;',
      'box-shadow:0 8px 28px rgba(0,0,0,.18);padding:10px 13px;z-index:9999;',
      'min-width:195px;max-height:330px;overflow-y:auto}',

      '.wbk-filter-label{display:flex;align-items:center;gap:8px;padding:5px 3px;',
      'cursor:pointer;font-size:.84rem;color:#333;user-select:none;border-radius:4px}',
      '.wbk-filter-label:hover{background:#f5f9f5;color:#2f5233}',
      '.wbk-filter-label--all{font-weight:600;border-bottom:1px solid #eee;padding-bottom:7px;margin-bottom:3px}',
      '.wbk-filter-label input[type=checkbox]{accent-color:#2f5233;width:15px;height:15px;flex-shrink:0;cursor:pointer}',

      '.wbk-filter-apply{flex:1;background:#2f5233;color:#fff;border:none;border-radius:5px;',
      'padding:7px 12px;cursor:pointer;font-size:.82rem;font-weight:600;transition:background .15s}',
      '.wbk-filter-apply:hover{background:#3d6b42}',
      '.wbk-filter-reset{background:#f0f0f0;color:#555;border:none;border-radius:5px;',
      'padding:7px 10px;cursor:pointer;font-size:.82rem;white-space:nowrap;transition:background .15s}',
      '.wbk-filter-reset:hover{background:#e2e2e2}',

      /* ── Ergebnis-Zähler ── */
      '.wbk-filter-count{font-size:.82rem;color:#888;margin-bottom:6px;font-style:italic;padding:0 2px}',

      /* ── Toast ── */
      '.wbk-toast{position:fixed;bottom:28px;left:50%;transform:translateX(-50%) translateY(16px);',
      'background:rgba(20,20,20,.92);color:#fff;padding:11px 22px;border-radius:8px;',
      'font-size:.88rem;z-index:99999;opacity:0;transition:opacity .25s,transform .25s;',
      'pointer-events:none;white-space:nowrap;box-shadow:0 4px 18px rgba(0,0,0,.28)}',
      '.wbk-toast--visible{opacity:1;transform:translateX(-50%) translateY(0)}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'wbk-table-interactive-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ══════════════════════════════════════════════════════════
  // INIT
  // ══════════════════════════════════════════════════════════

  function init() {
    injectStyles();
    initRowSelection();
    initColumnFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
